import type { ReactNode } from 'react'
import { PointProgramText } from '~/components/PointProgram'
import { useCalendarStateValue } from '~/stores/calendar/state'
import { css, sva } from '~/styled-system/css'
import type { RecipeVariantProps } from '~/styled-system/css'
import { center } from '~/styled-system/patterns'
import { Selection } from './Selection'
import { ToReservation } from './ToReservation'
import { VisitDateCalendar } from './VisitDateCalendar'
import { VisitTime } from './VisitTime'
import { VisitorsCount } from './VisitorsCount'

const styles = sva({
  slots: ['container', 'reserve', 'point'],
  base: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      gap: '4',
    },
  },
  variants: {
    mode: {
      sd: {
        container: {
          // ToReserve ボタンを sticky にするため
          pt: '4',
        },
        reserve: {
          position: 'sticky',
          bottom: '0',
          left: '0',
          width: 'full',
          bg: 'white',
          p: '4',
          shadow: 'outline.lg',
        },
      },
      pc: {
        container: {
          py: '5',
        },
        reserve: {
          px: '4',
        },
        point: {
          mx: 'auto',
          _empty: {
            display: 'none',
          },
        },
      },
      pcModal: {
        container: {
          py: '4',
        },
        reserve: {
          px: '4',
        },
      },
    },
  },
})

export type DateTimeSelectionStyleProps = RecipeVariantProps<typeof styles>

export function DateTimeSelection({
  hideMealPeriodTab,
  showIkyuDayBalloon,
  isLoading,
  filter,
  clear,
  mode,
}: {
  hideMealPeriodTab?: boolean
  showIkyuDayBalloon?: boolean
  isLoading?: boolean
  filter?: ReactNode
  clear?: ReactNode
} & DateTimeSelectionStyleProps) {
  const state = useCalendarStateValue()
  const showSelectMessage = state === 'CLEARED' || state === 'VISITORS_COUNT_UNKNOWN'
  const classes = styles({ mode })
  return (
    <div className={classes.container}>
      <div className={classes.point}>
        {mode === 'pc' && <PointProgramText type="short" showIkyuDayBalloon={showIkyuDayBalloon} />}
      </div>
      {filter}
      <div className={css({ spaceY: '4', px: '4' })}>
        <Selection label="人数">
          <VisitorsCount />
        </Selection>
        <VisitDateCalendar hideMealPeriodTab={hideMealPeriodTab} />
        {showSelectMessage ? (
          <div className={center()}>人数・日付を選択してください</div>
        ) : (
          <Selection label="時間">
            <VisitTime />
          </Selection>
        )}
      </div>
      <ToReservation
        isLoading={isLoading}
        className={classes.reserve}
        color={mode === 'pcModal' ? 'secondarySolid' : mode === 'pc' ? 'primary' : 'secondary'}
        size={mode === 'pc' ? 'lg' : 'md'}
      />
      {clear}
    </div>
  )
}
